module.exports = "/_next/static/images/lawfully-pro-1aa13e8dcaf5dca2efd3954cd5829917.png";